"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEncryptionType = exports.DEFAULT_DISPLAY_PREFERENCE = exports.IHashType = exports.IAuthType = exports.IAuth = void 0;
/**
 * Enum for Authentication Type
 * Specifies different types of authentication mechanisms.
 */
var IAuth;
(function (IAuth) {
    IAuth["BASIC"] = "BASIC";
    IAuth["SSO"] = "SSO";
})(IAuth = exports.IAuth || (exports.IAuth = {}));
var IAuthType;
(function (IAuthType) {
    IAuthType["SAML"] = "saml";
    IAuthType["AD"] = "ad";
    IAuthType["CUSTOMJWT"] = "customjwt";
    IAuthType["DISABLE"] = "disabled";
})(IAuthType = exports.IAuthType || (exports.IAuthType = {}));
/**
 * Enum for Hashing Algorithm Type
 * Specifies different hashing algorithms for password hashing.
 */
var IHashType;
(function (IHashType) {
    IHashType["MD5"] = "md5";
    IHashType["SHA1"] = "sha1";
    IHashType["SHA256"] = "sha256";
})(IHashType = exports.IHashType || (exports.IHashType = {}));
exports.DEFAULT_DISPLAY_PREFERENCE = [
    {
        id: 1,
        name: "Dashboard",
        nodes: [],
    },
    {
        id: 2,
        name: "Setup Apps",
        nodes: [
            {
                id: 21,
                name: "Setup New App",
                p: 1,
                nodes: [],
            },
            {
                id: 22,
                name: "Setup New Chatbot",
                p: 2,
                nodes: [],
            },
        ],
    },
    {
        id: 3,
        name: "Users",
        nodes: [
            {
                id: 31,
                name: "Demographics",
                p: 1,
                nodes: [],
            },
            {
                id: 32,
                name: "Audience Segments",
                p: 2,
                nodes: [],
            },
        ],
    },
    {
        id: 4,
        name: "Acquistion",
        nodes: [
            {
                id: 41,
                name: "App Aquisition",
                p: 1,
                nodes: [],
            },
            {
                id: 42,
                name: "Upload Past Data",
                p: 2,
                nodes: [],
            },
        ],
    },
    {
        id: 5,
        name: "Activities",
        nodes: [
            {
                id: 51,
                name: "Inside the app",
                p: 1,
                nodes: [
                    {
                        id: 511,
                        name: "Usage",
                        p: 1,
                    },
                    {
                        id: 512,
                        name: "Events",
                        p: 2,
                    },
                    {
                        id: 513,
                        name: "Funnels",
                        p: 3,
                    },
                    {
                        id: 514,
                        name: "Screen Playback",
                        p: 4,
                    },
                    {
                        id: 515,
                        name: "Journey",
                        p: 5,
                    },
                ],
            },
            {
                id: 52,
                name: "Outside the app",
                p: 2,
                nodes: [],
            },
        ],
    },
    {
        id: 6,
        name: "Engagement",
        nodes: [
            {
                id: 61,
                name: "Campaigns",
                p: 1,
                nodes: [],
            },
            {
                id: 62,
                name: "Transactional Campaigns",
                p: 2,
                nodes: [],
            },
        ],
    },
    {
        id: 7,
        name: "Churn",
        nodes: [],
    },
    {
        id: 8,
        name: "Settings",
        nodes: [
            {
                id: 81,
                name: "Manage Modules",
                p: 1,
                nodes: [],
            },
            {
                id: 82,
                name: "User Management",
                p: 2,
                nodes: [],
            },
            {
                id: 83,
                name: "Upload Test Data",
                p: 3,
                nodes: [],
            },
            {
                id: 84,
                name: "Display Preference",
                p: 4,
                nodes: [],
            },
            {
                id: 85,
                name: "App Setting",
                p: 5,
                nodes: [],
            },
            {
                id: 86,
                name: "Playback Setting",
                p: 6,
                nodes: [],
            },
        ],
    },
    {
        id: 9,
        name: "Documentation",
        nodes: [
            {
                id: 91,
                name: "Android Studio Integration",
                p: 1,
                nodes: [],
            },
            {
                id: 92,
                name: "iOS Integration",
                p: 2,
                nodes: [],
            },
            {
                id: 93,
                name: "Cordova Integration",
                p: 3,
                nodes: [],
            },
            {
                id: 94,
                name: "React Integration",
                p: 4,
                nodes: [],
            },
        ],
    },
    {
        id: 10,
        name: "Reports",
        nodes: [
            {
                id: 101,
                name: "Exports ",
                p: 1,
                nodes: [],
            },
        ],
    },
];
;
//we can add more algorithms if needed if the logic becomes complex
var IEncryptionType;
(function (IEncryptionType) {
    IEncryptionType["AES_256_GCM"] = "aes-256-gcm";
})(IEncryptionType = exports.IEncryptionType || (exports.IEncryptionType = {}));
;
